import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { articlesReducer } from './reducers';

import { initialState } from './state';

export const articlesSlice = createSlice({
  name: 'article',
  initialState,
  reducers: {
    setHasPremiumArticleEloquaForm(state, { payload }: PayloadAction<boolean>) {
      return { ...state, hasPremiumArticleEloquaForm: payload };
    },
    ...articlesReducer,
  },
});

export const articlesActions = articlesSlice.actions;
